import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=08805179&scoped=true&"
import script from "./Line.vue?vue&type=script&lang=ts&"
export * from "./Line.vue?vue&type=script&lang=ts&"
import style0 from "./Line.vue?vue&type=style&index=0&id=08805179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08805179",
  null
  
)

export default component.exports